<template>
  <div class="relative">
    <info-header :title="title" />
    <welcome-message v-if="isNewLandscape" />
    <div v-else class="p-5 desktop:p-6 section-scroll">
      <info-content :managers="managers" />
    </div>
    <transition name="slide-in-right">
      <router-view />
    </transition>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import gsap from 'gsap'
import InfoHeader from '@/components/landscape/info/InfoHeader'
import InfoContent from '@/components/landscape/info/InfoContent'
import WelcomeMessage from '@/components/landscape/info/WelcomeMessage'

export default {
  name: 'Info',
  components: {
    InfoContent,
    WelcomeMessage,
    InfoHeader
  },
  data() {
    return {
      text: ''
    }
  },
  computed: {
    ...mapGetters([
      'selectedActor',
      'currentLandscape',
      'hasAdminRights',
      'hasManagerRights',
      'managerList',
      'adminList',
      'owner'
    ]),
    isNewLandscape() {
      return !this.landscapeHasActors && this.hasManagerRights
    },
    title() {
      return (
        (this.selectedActor && this.selectedActor.name) ||
        this.currentLandscape.name
      )
    },
    landscapeHasActors() {
      return this.currentLandscape.actors.length !== 0
    },
    managers() {
      if (!this.selectedActor) return []
      let managers = this.managerList
      if (managers.length === 0) {
        managers = this.adminList
      }
      if (managers.length === 0) {
        managers = [this.owner]
      }
      return managers.map(user => user._id)
    }
  },
  watch: {
    selectedActor() {
      this.loadActorStats()
    },
    currentLandscape(newValue, oldValue) {
      if (newValue._id !== oldValue._id) {
        gsap.to('.InfoView', 1, {
          opacity: 1.2,
          startAt: {opacity: 0},
          ease: 'power3.in'
        })
      }
    }
  },
  created() {
    this.loadActorStats()
  },
  methods: {
    loadActorStats() {
      if (this.selectedActor) {
        this.$store.dispatch('loadActorStats')
      }
    }
  }
}
</script>

<style scoped>
.WordCloudView {
}
</style>
